import { render, staticRenderFns } from "./TextSearch.vue?vue&type=template&id=e58bb5c6&scoped=true&"
import script from "./TextSearch.vue?vue&type=script&lang=js&"
export * from "./TextSearch.vue?vue&type=script&lang=js&"
import style0 from "./TextSearch.vue?vue&type=style&index=0&id=e58bb5c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58bb5c6",
  null
  
)

export default component.exports